import { gql } from '@apollo/client'
/**
 * GraphQL Mutation Search Payee.
 * @function SEARCH_PAYEES_MUTATION
 * Returns the GraphQL mutation string (e.g. `mutation createNewPayee { payeeId, payeeStatus }`).
 * @return {payeeId, payeeStatus} response data.
 */
/* E.g. variables: {
    "appName": "BILLPAY",
    "payeeCreateRequest": {
     "name": "test"
    }
} */

export const SEARCH_PAYEES_MUTATION = gql`
  mutation createBillpayPayee(
    $appName: AppNameEnum
    $payeeCreateRequest: BillpayPayeeCreateRequest
  ) {
    createBillpayPayee(
      appName: $appName
      payeeCreateRequest: $payeeCreateRequest
    ) {
      payee {
        payeeId
        payeeStatus
      }
    }
  }
`
export default SEARCH_PAYEES_MUTATION
